import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: `${_ctx.accountAppItem.id ? '编辑' : '创建'}APP`,
    modelValue: _ctx.selfVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selfVisible) = $event)),
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    "custom-class": "dialog-width-small",
    center: "",
    top: "5vh",
    onClose: _ctx.handleAPPClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          onClick: _ctx.handleAPPClose,
          size: "default"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取 消 ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "default",
          onClick: _ctx.handleAPPSave
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确 定 ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: false,
        "label-width": "120px",
        rules: _ctx.rules,
        model: _ctx.formData,
        ref: "ruleAppForm",
        size: "default"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "bundle-id",
            prop: "bundleId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.bundleId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.bundleId) = $event)),
                modelModifiers: { trim: true },
                placeholder: "请输入bundle-id",
                maxlength: "200"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "应用名称",
            prop: "appClient"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.appClient,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.appClient) = $event)),
                placeholder: "请选择应用名称",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appList, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: '_' + index,
                      label: item.appName,
                      value: item.appCode
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "下载地址",
            prop: "installAddress"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.installAddress,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.installAddress) = $event)),
                modelModifiers: { trim: true },
                placeholder: "请输入下载地址",
                maxlength: "200"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onClose"]))
}